module.exports = __webpack_public_path__ + "img/img-3-12mobile.260f8b19.webp";